import React from "react";
import Steps from "./steps";
import { Progress } from "./Progress";
import { Divider } from "antd";

export const Content = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="row justify-content-md-center">
          <div className="col-md-auto">
            <Progress className="d-none d-md-block start-0" />
          </div>

          <div className="col col-1">
            <Divider
              className="d-none d-md-block"
              style={{ height: "400px" }}
              type="vertical"
            />
          </div>

          <div className="col col-6">
            <Steps />
          </div>
        </div>
      </div>
    </>
  );
};
